import React from 'react';
import PropTypes from 'prop-types';
import { Field } from 'redux-form';
import './ModemSelect.scss';
import WidgetMode from '../WidgetMode';

const ModemSelect = (props) => {
  const { id, name, label } = props;
  return (
    <div>
      <Field
        name={name}
        component={(options) => {
          const hasError = options.meta.touched && options.meta.error;
          return (
            <div className="modem-type">
              <div className="modem-type-label">{label}</div>
              <div className={`modem-types-container${hasError ? ' switch-error' : ''}`}>
                <input
                  id={`${id}-hg659`}
                  type="radio" {...options.input}
                  value={WidgetMode.hg659.name}
                  checked={options.input.value === WidgetMode.hg659.name}
                />
                <label htmlFor={`${id}-hg659`} id={`autotest-${id}-hg659`}>
                  <div className="modem-type-hg659" />
                  {WidgetMode.hg659.name}
                </label>

                <input
                  id={`${id}-smart`}
                  type="radio"
                  {...options.input}
                  value={WidgetMode.smartModem.name}
                  checked={options.input.value === WidgetMode.smartModem.name}
                />
                <label htmlFor={`${id}-smart`} id={`autotest-${id}-smart`}>
                  <div className="modem-type-smart" />
                  {WidgetMode.smartModem.name}
                </label>
              </div>
              {hasError &&
              <div className="modem-type-error">Please click one</div>
              }
            </div>
          );
        }
        }
      />
    </div>
  );
};

ModemSelect.propTypes = {
  id: PropTypes.string,
  label: PropTypes.string,
  name: PropTypes.string
};

export default ModemSelect;



/** WEBPACK FOOTER **
 ** ./src/components/ContactUs/ModemSelect/ModemSelect.js
 **/